import React from 'react';
import { func } from 'prop-types';

import ActionsPanelItem from '../../components/ActionsPanelItem';

import classes from './ActionInsert.module.css';

const ClientActionInsert = ({
    onToggleCreateCampusModal,
    onToggleCreateContactModal,
    onToggleCreateSiteModal,
    onToggleDeleteClientModal,
    onToggleEditEntityModal
}) => (
    <div className={classes.agentActions}>
        <ActionsPanelItem
            title="Edit Client Information"
            iconUrl="/assets/images/clientTreeIcon.svg"
            onClick={() => onToggleEditEntityModal(true)}
        />
        <ActionsPanelItem
            title="Delete Client"
            iconUrl="/assets/images/deleteIconColor.svg"
            onClick={() => onToggleDeleteClientModal(true)}
        />
        {
            process.env.contactsEnabled ?
                null
                :
                <ActionsPanelItem
                    title="Create a new Contact"
                    iconUrl="/assets/images/contactIconColor.svg"
                    onClick={() => onToggleCreateContactModal(true)}
                />
        }
        <ActionsPanelItem
            title="Create a new Campus"
            iconUrl="/assets/images/campusTreeIcon.svg"
            onClick={() => onToggleCreateCampusModal(true)}
        />
        <ActionsPanelItem
            title="Create a new Site"
            iconUrl="/assets/images/siteTreeIcon.svg"
            onClick={() => onToggleCreateSiteModal(true)}
        />
    </div>
);

ClientActionInsert.defaultProps = {
    onToggleDeleteClientModal: () => { },
    onToggleEditEntityModal:   () => { }
};

ClientActionInsert.propTypes = {
    onToggleDeleteClientModal: func,
    onToggleEditEntityModal:   func
};

export default ClientActionInsert;
